import { Backdrop, CircularProgress } from "@mui/material";
import Listtable from "components/common/ListTable";
import useMasterList from "./useMasterList";
import MasterToolbar, { RowActions, StatusChip } from "./MasterToolbar";
import LifecycleDialog from "./LifecycleDialog";

const MasterListScreen = ({
  resource,
  label,
  entityLabel,
  addLabel,
  tag,
  headers,
  keys,
  displayName,
  mapRow,
  Modal,
  searchText = "",
}) => {
  const list = useMasterList({ resource, searchText, label });

  const tableRows = list.rows.map((item) => ({
    ...item,
    name: displayName(item),
    ...(mapRow ? mapRow(item) : {}),
    statusChip: <StatusChip status={item.lifecycleStatus} />,
    action: (
      <RowActions
        record={item}
        onEdit={list.openEdit}
        onLifecycle={(record) =>
          list.setLifecycleTarget({
            ...record,
            displayName: displayName(record),
          })
        }
      />
    ),
  }));

  return (
    <>
      <MasterToolbar
        addLabel={addLabel}
        onAdd={list.openCreate}
        lifecycleStatus={list.lifecycleStatus}
        onLifecycleStatusChange={list.setLifecycleStatus}
        busy={list.busy}
      />

      <Listtable
        tableheader={headers}
        tablebody={tableRows}
        rowsPerPage={list.rowsPerPage}
        page={list.pageNumber}
        handleChangePage={list.handleChangePage}
        handleChangeRowsPerPage={list.handleChangeRowsPerPage}
        totalCount={list.count}
        dataKeyName={keys}
        tag={tag}
      />

      {list.modalOpen && (
        <Modal
          open={list.modalOpen}
          onClose={list.handleModalClose}
          data={list.activeRecord}
        />
      )}

      <LifecycleDialog
        open={Boolean(list.lifecycleTarget)}
        record={list.lifecycleTarget}
        entityLabel={entityLabel}
        busy={list.busy}
        onCancel={() => list.setLifecycleTarget(null)}
        onConfirm={list.submitLifecycle}
      />

      <Backdrop
        open={list.loading || list.busy}
        sx={{ zIndex: 1200, color: "#fff" }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default MasterListScreen;
